import constellationNetwork from "../assets/constellation-network.png";
import styles from "./ConstellationDecoration.module.css";

/** 좌측 시각 영역 상단 오른쪽 장식 — 별자리 네트워크 이미지 */
export function ConstellationDecoration({ className }: { className?: string }) {
  return (
    <img
      className={[styles.image, className].filter(Boolean).join(" ")}
      src={constellationNetwork}
      alt=""
      aria-hidden
      draggable={false}
    />
  );
}
